module.exports = {
  emailPerceptionReport: 1,
  emailPredictionReport: 2
};
